export const Splash = () => (
  <div className="flex min-h-screen items-center justify-center bg-[#0b132b]" data-testid="app-splash">
    <img src="/logo-mark.png" alt="FOOTZA" className="h-16 w-auto animate-pulse" />
  </div>
);
